var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.687 13.3693C15.0085 13.3693 17.7011 10.6925 17.7011 7.39045C17.7011 4.08843 15.0085 1.41162 11.687 1.41162C8.36546 1.41162 5.67285 4.08843 5.67285 7.39045C5.67285 10.6925 8.36546 13.3693 11.687 13.3693Z","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M2.41162 22.5882C2.47818 20.179 3.48198 17.8908 5.20955 16.2103C6.93711 14.5298 9.25212 13.5896 11.6622 13.5896C14.0723 13.5896 16.3873 14.5298 18.1149 16.2103C19.8424 17.8908 20.8462 20.179 20.9128 22.5882","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

User.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = User;

User.default = User;
